import React, { PropsWithChildren } from 'react';

import { DropzoneOptions, useDropzone } from 'react-dropzone';

type Props = PropsWithChildren<{
  options?: DropzoneOptions;
  className?: string;
}>;

export const Dropzone = ({ children, className, options }: Props) => {
  const { getInputProps, getRootProps } = useDropzone(options);
  return (
    <div className={className} {...getRootProps()}>
      <input {...getInputProps()} />
      {children}
    </div>
  );
};
